import pack from '../../package.json'
import axiosReq from 'axios'


const reqUrl = '/commons/error-log'

const errorLogReq = (error, type) => {
  axiosReq({
    url: import.meta.env.VITE_API_URL + reqUrl,
    data: {
      type: type,
      pageUrl: window.location.href,
      name: error.name,
      message: error.message,
      stack: error.stack,
      browserType: navigator.userAgent,
      version: pack.version
    },
    method: 'post'
  }).then(() => {
  })
}

export const useErrorLog = (error) => {
  if (import.meta.env.VITE_APP_SEND_ERRORS == "true") {
    errorLogReq(error, "ERROR");
  }
}

export const useWarningLog = (error) => {
  if (import.meta.env.VITE_APP_ENV == "dev") {
    //console.log(error);
    errorLogReq(error, "WARNING");
  }
}

export const useGlobalErrorLog = () => {
  if (import.meta.env.VITE_APP_SEND_ERRORS == "true") {
    window.onerror = function(message, source, lineno, colno, error) {
      errorLogReq(error, "GLOBAL_ERROR");
    }
  }
}